<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <div class="d-flex justify-content-between">
        <h3 class="mb-0">Todos los Productores</h3>
        <button
          class="btn btn-neutral btn-sm btn-wd"
          title="exportProducers"
          @click="exportProducers"
          v-if="$can('export', 'producers')"
        >
          <i class="fas fa-download"></i>&nbsp;Exportar Productores
        </button>
      </div>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>
        <div>
          <base-input
            v-model="searchCityQuery"
            placeholder="Buscar Ciudad..."
            prepend-icon="fas fa-search"
          ></base-input>
        </div>
        <div>
          <base-input v-model="mixSearchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Razón Social" min-width="170px" prop="business_name" sortable>
          <template #default="{ row }">
            <div>{{ row.businessName }}</div>
            <small><span class="font-weight-bold mr-1">CUIT</span>{{ row.cuit }}</small>
          </template>
        </el-table-column>

        <el-table-column label="Distribuidor" min-width="160px" prop="distributor" sortable>
          <template #default="{ row }">
            <div v-if="row.distributor">
              <router-link
                v-if="$can('show', 'distributors')"
                :to="{
                  name: 'DistributorShow',
                  params: { id: row.distributor.id },
                }"
                class="h5"
              >
                {{ row.distributor.name }}
              </router-link>
              <span v-else class="h5">{{ row.distributor.name }}</span>
              <div v-if="row.distributor.seller">
                <router-link
                  v-if="$can('show', 'sellers')"
                  :to="{
                    name: 'SellerShow',
                    params: { id: row.distributor.seller.id },
                  }"
                  class="h5"
                >
                  {{ row.distributor.seller.name }}
                </router-link>
                <span v-else class="h5">{{ row.distributor.seller.name }}</span>
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column label="Localidad" min-width="130px" prop="city" sortable>
          <template #default="{ row }">
            <div v-if="row.city">{{ row.city.name }}, {{ row.city.province.name }}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column label="Última visita" min-width="140px" prop="last_visit">
          <template #default="{ row }">
            <div class="text-center">
              <small v-if="row.lastVisit">
                {{ row.lastVisit.visitDate | date }}
              </small>
              <small v-else> - </small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Maíz" min-width="80px" prop="corn" sortable>
          <template #default="{ row }">
            <div v-if="row.corn">{{ row.corn }}</div>
            <div v-else>{{ row.corn }}</div>
          </template>
        </el-table-column>

        <el-table-column label="M.Silero" min-width="80px" prop="storage_corn" sortable>
          <template #default="{ row }">
            <div v-if="row.storageCorn">{{ row.storageCorn }}</div>
            <div v-else>{{ row.storageCorn }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Alfalfa" min-width="80px" prop="alfalfa" sortable>
          <template #default="{ row }">
            <div v-if="row.alfalfa">{{ row.alfalfa }}</div>
            <div v-else>{{ row.alfalfa }}</div>
          </template>
        </el-table-column>

        <el-table-column label="" min-width="115px" prop="visitsCount">
          <template #default="{ row }">
            <badge class="m-1" type="primary"> {{ row.plotsCount }} lotes </badge>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="190px">
          <div slot-scope="{ row }" class="d-flex flex-wrap">
            <router-link
              v-if="$can('show', 'producers')"
              :to="{ name: 'ProducerShow', params: { id: row.id } }"
              title="Ver"
              class="btn base-button btn-outline-info btn-sm m-1"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <router-link
              v-if="$can('update', 'producers')"
              :to="{ name: 'ProducerEdit', params: { id: row.id } }"
              title="Editar"
              class="btn base-button btn-outline-primary btn-sm m-1"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <router-link
              v-if="$can('index', 'projections')"
              :to="{ name: 'ProducerProjections', params: { id: row.id } }"
              class="btn base-button btn-outline-warning btn-sm m-1"
            >
              <i class="fas fa-chart-line"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'producers')"
              title="Eliminar"
              class="btn base-button btn-outline-danger btn-sm m-1"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} productores
        </p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';
import CitySearchOnServerMixin from '@/mixins/citySearchOnServerMixin';
import swal from 'sweetalert2';

export default {
  name: 'ProducersTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationOnServerMixin, DeleteRowFromTableMixin, CitySearchOnServerMixin],
  data() {
    return {
      tableData: [],
      modelName: 'producer',
    };
  },

  created() {
    this.defaultSort = 'business_name';
    this.fetchTableData();

    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el productor';
    this.alertSuccessSettings.message = 'El productor ha sido eliminado';
    this.resourceName = 'producers';
  },

  methods: {
    async exportProducers() {
      try {
        const response = await this.$services.resource('producers').getExportProducers();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'producers.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Hubo un problema al descargar el archivo. Por favor, intenta de nuevo más tarde.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success',
          type: 'error',
        });
      }
    },
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;
      this.searchCityQuery = this.city || this.searchCityQuery;

      const parameters = {
        append: 'lastvisit',
        include: ['city.province', 'plotsCount', 'distributor.seller'],
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sort: this.sort || this.defaultSort,
        'filter[search]': this.mixSearchQuery,
        'filter[search_city]': this.searchCityQuery,
      };
      this.$services
        .resource('producers')
        .get(parameters)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.producers));
    },
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
